import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importar archivos de traducción
import esTranslations from './locales/es.json';
import enTranslations from './locales/en.json';

// Función para detectar el idioma preferido del usuario
const detectUserLanguage = () => {
  try {
    // Verificar si ya hay un idioma guardado en localStorage
    const savedLanguage = localStorage.getItem('i18nextLng');
    if (savedLanguage && (savedLanguage === 'es' || savedLanguage === 'en')) {
      return savedLanguage;
    }

    // Obtener todos los idiomas del navegador
    const browserLangs = navigator.languages || [navigator.language];
    console.log('🌍 [LANDING] Idiomas del navegador detectados:', browserLangs);
    console.log('🌍 [LANDING] Idioma principal:', navigator.language);
    
    // Buscar español en cualquier posición de la lista
    for (const lang of browserLangs) {
      if (lang && (lang.startsWith('es') || lang.startsWith('es-') || lang.includes('es'))) {
        console.log('🌍 [LANDING] Idioma detectado: Español', lang);
        return 'es';
      }
    }
    
    // Buscar inglés en cualquier posición de la lista
    for (const lang of browserLangs) {
      if (lang && lang.startsWith('en')) {
        console.log('🌍 [LANDING] Idioma detectado: Inglés', lang);
        return 'en';
      }
    }
    
    // Fallback: detectar por zona horaria para usuarios de Latinoamérica
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const latamTimezones = [
      'America/Argentina', 'America/Bogota', 'America/Caracas', 'America/Lima',
      'America/Mexico_City', 'America/Santiago', 'America/Sao_Paulo',
      'America/Guatemala', 'America/Tegucigalpa', 'America/Managua',
      'America/Panama', 'America/Asuncion', 'America/Montevideo'
    ];
    
    if (latamTimezones.some(tz => timezone.includes(tz))) {
      console.log('🌍 [LANDING] Idioma detectado por zona horaria: Español', timezone);
      return 'es';
    }

    // Fallback: detectar por país usando geolocalización de IP (si está disponible)
    if (navigator.geolocation) {
      // Esto es asíncrono, pero podemos intentar detectar por otros medios
      console.log('🌍 [LANDING] Geolocalización disponible, pero no podemos usarla de forma síncrona');
    }
    
    console.log('🌍 [LANDING] Idioma por defecto: Inglés (no se pudo detectar)');
  } catch (error) {
    console.log('🌍 [LANDING] Error detecting language:', error);
  }
  
  // Default a inglés si no se puede detectar
  return 'en';
};

// Detectar idioma antes de inicializar i18n
const detectedLanguage = detectUserLanguage();

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: {
        translation: esTranslations
      },
      en: {
        translation: enTranslations
      }
    },
    lng: detectedLanguage, // Establecer idioma inicial basado en detección
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      // Configurar el detector para que use nuestra función personalizada
      convertDetectedLanguage: (lng) => {
        // Si ya hay un idioma guardado en localStorage, usarlo
        if (localStorage.getItem('i18nextLng')) {
          return lng;
        }
        // Si no, usar nuestra detección personalizada
        return detectUserLanguage();
      }
    },
    
    interpolation: {
      escapeValue: false, // React ya escapa por defecto
    },
  });

// Función para forzar la detección de idioma (útil para usuarios nuevos)
export const forceLanguageDetection = () => {
  const newLanguage = detectUserLanguage();
  if (newLanguage !== i18n.language) {
    i18n.changeLanguage(newLanguage);
    console.log('🌍 [LANDING] Idioma cambiado a:', newLanguage);
  }
  return newLanguage;
};

export default i18n;
